export default __webpack_public_path__ + "assets/png/8b44ed92f6e442c0e2858018a949bcb4.png";